<script setup lang="ts">
import { computed } from 'vue';

interface DirectusImageProps {
  uuid: string;
  alt?: string;
  width?: string;
  height?: string;
  sizes?: string;
  densities?: number[];
  class?: string;
  modifiers?: Record<string, any>;
  // any other Nuxt Image props you actually use…
  fit?: 'cover' | 'contain' | 'fill' | 'inside' | 'outside';
}

const props = defineProps<DirectusImageProps>();

const passProps = computed(() => {
  // Strip uuid and undefined values
  const { uuid, ...rest } = props as any;
  const clean: Record<string, any> = {};
  for (const [k, v] of Object.entries(rest)) {
    if (v !== undefined) clean[k] = v;
  }
  // if no sizes nor width/height, set a default width
  if (!clean.sizes && !clean.width && !clean.height) {
    clean.width = '100vw';
  }
  // console.log('DirectusImage passProps:', clean);
  return clean;
});
</script>

<template>
  <NuxtImg provider="directus" :src="props.uuid" v-bind="passProps" />
</template>
